import { render, staticRenderFns } from "./CashOnDeliveryModal.vue?vue&type=template&id=0120bf69&"
import script from "./CashOnDeliveryModal.vue?vue&type=script&lang=js&"
export * from "./CashOnDeliveryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports